<!-- Shown while waiting for application load to complete before routing -->
@if (!initialCheckComplete) {
  <div class="loading-container">
    <svg lucideLoaderCircle class="lucide-spin"></svg>
  </div>
}
